import module from 'nominas/nomina/module.js'
import template from './template.html'
import './style.scss'

export class NominasNominaDispersionPagosProgresoComponent {
  data = []
  totales = []

  $onChanges (changes) {
    if (changes.data) {
      this.totales = [
        {descripcion: 'Completados', total: this.data.pagos_completados || 0, color: '#5AB517'},
        {descripcion: 'En proceso', total: this.data.pagos_en_proceso || 0, color: '#99BEAF'},
        {descripcion: 'Pendientes', total: this.data.pagos_pendientes || 0, color: '#CCCCCC'},
        {descripcion: 'Retenidos', total: this.data.pagos_retenidos || 0, color: '#e7a04f'},
      ]

      this.total = this.totales.reduce((total, item) => total + item.total, 0)

      this.totales = this.totales
        .filter((item) => item.total > 0)
        .map((item) => ({...item, valor: item.total / this.total}))
    }
  }
}

module.component('nominasNominaDispersionPagosProgreso', {
  controller: NominasNominaDispersionPagosProgresoComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/progreso/component.js